import { theme } from 'rebass'

const themeColors = {
  primaryDark: 'rgb(34,34,34)',
  secondaryDark: '#333',
  grayText: '#999',
  white: '#fff',
  yellow: '#F9CE06',
}

export default { ...theme.colors, ...themeColors }



// WEBPACK FOOTER //
// ./src/config/colors.js